import {
  FETCH_DELETELIST_REQUEST,
  FETCH_DELETELIST_SUCCESS,
  FETCH_DELETELIST_FAILURE,
} from "./reletedPartiesDeleteTypes";

const initialState = {
  loading: false,
  deleteList: [],
  error: "",
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DELETELIST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_DELETELIST_SUCCESS:
      return {
        loading: false,
        deleteList: action.payload,
        error: "",
      };
    case FETCH_DELETELIST_FAILURE:
      return {
        loading: false,
        deleteList: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
